import { TrendingUp } from "lucide-react";
import type { DashboardTarget } from "@/lib/api/dashboard";
import { useDashboardWidget } from "@/lib/hooks/use-dashboard";
import { useT } from "@/lib/i18n/use-t";
import { useDashboardFormat } from "../use-dashboard-format";
import { T } from "./flows-widget.i18n";
import { KeyFigureValue } from "./key-figure-value";
import { StatsCard } from "./stats-card";

/** Today's Total Flows figure, unchanged. */
export function FlowsWidget({ target }: { target: DashboardTarget }) {
  const { data, isLoading, error } = useDashboardWidget("flows", target);
  const t = useT(T);
  const { count } = useDashboardFormat();
  return (
    <StatsCard
      icon={TrendingUp}
      label={t.totalFlows}
      value={
        <KeyFigureValue isLoading={isLoading} error={error}>
          {data && count(data.draft + data.inProgress + data.completed)}
        </KeyFigureValue>
      }
      subtitle={
        data &&
        t.flowsSubtitle({
          draft: count(data.draft),
          active: count(data.inProgress),
          completed: count(data.completed),
        })
      }
    />
  );
}
